export class KPIModel {
  public charts: any;
  public kpis: { text: string; value: number | string }[];
  constructor(kpis: any) {
    this.charts = kpis.charts;
    this.kpis = kpis.kpis;
  }
}
